import React from 'react';
import { Helmet } from "react-helmet";

const SEO = ({ title, description, path, schema }) => {
  const defaultSchema = {
    "@context": "https://schema.org",
    "@type": path === 'game' ? 'VideoGame' : (path === 'store' ? 'Store' : 'WebPage'),
    "name": `${title} | WHATIF Dungeon For Riches`,
    "description": description,
    "url": `https://rewardsinwhatif.app/${path}`,
    "image": "https://rewardsinwhatif.app/social-preview.png",
    ...(path === 'game' && {
      "genre": "RPG",
      "gamePlatform": "Web Browser",
      "applicationCategory": "Game",
      "operatingSystem": "Any"
    })
  };

  const finalSchema = schema || defaultSchema;

  return (
    <Helmet>
      <title>{title} | WHATIF Dungeon For Riches</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`https://rewardsinwhatif.app/${path}`} />

      {/* Open Graph / Facebook / Discord */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`https://rewardsinwhatif.app/${path}`} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content="https://rewardsinwhatif.app/social-preview.png" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={`https://rewardsinwhatif.app/${path}`} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content="https://rewardsinwhatif.app/social-preview.png" />

      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(finalSchema)}
      </script>
    </Helmet>
  );
};

export default SEO;
